import React from 'react';
import { useDialogStore } from './useDialogStore';

/**
 * Component to render dialogs from the dialog store.
 */
export const DialogStore = () => {
  const { dialogs } = useDialogStore();

  if (!dialogs.length) {
    return null;
  }

  return <>{dialogs?.map(dialog => dialog.component)}</>;
};
